import React from "react";
import { Box, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import Login from "./login";
import Signup from "./signup";
import ThemeSwitcher from "../ThemeSwitcher";
import i18n from "i18";
import ComponentAbstract from "components/ComponentAbstract";
import { useNavigate, useLocation } from "react-router-dom";

class AuthPageBase extends ComponentAbstract {
  constructor(props) {
    super(props);

    const path = props.location?.pathname || "/auth/login";
    const mode = path.includes("signup") ? "signup" : "login";

    this.state = {
      ...this.state,
      mode,
    };
  }

  handleModeChange = (event, newMode) => {
    if (newMode !== null) {
      this.setState({ mode: newMode });
      this.props.navigate(`/auth/${newMode}`);
    }
  };

  tr(key) {
    return i18n.t(`auth.${key}`);
  }

  renderToggle() {
    const { mode } = this.state;

    return (
      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={this.handleModeChange}
        sx={{
          width: "100%",
          backgroundColor: "var(--input-bg)",
          borderRadius: "12px",
          padding: "4px",
          border: "none",
          "& .MuiToggleButtonGroup-grouped": {
            border: "none",
            borderRadius: "10px !important",
            flex: 1,
            height: "44px",
            fontFamily: "Montserrat, sans-serif",
            fontSize: "15px",
            fontWeight: "600",
            textTransform: "none",
            transition: "all 0.3s ease",
            color: "var(--text-secondary)",
            "&:hover": {
              backgroundColor: "transparent",
              color: "var(--text-color)",
            },
            "&.Mui-selected": {
              backgroundColor: "var(--accent-primary)",
              color: "#fff",
              "&:hover": {
                backgroundColor: "var(--accent-primary)",
                color: "#fff",
              },
            },
          },
        }}>
        <ToggleButton value="login">{this.tr("login")}</ToggleButton>
        <ToggleButton value="signup">{this.tr("signup")}</ToggleButton>
      </ToggleButtonGroup>
    );
  }

  renderForm() {
    const { mode } = this.state;

    if (mode === "signup") {
      return <Signup navigate={this.props.navigate} hideHeader />;
    }

    return <Login navigate={this.props.navigate} hideHeader />;
  }

  render() {
    const { mode } = this.state;
    const mainTitle = mode === "login" ? "loginMain" : "signupMain";
    const smallTitle = mode === "login" ? "loginSmall" : "signupSmall";

    return (
      <Box
        className="flex1"
        sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
        <Box
          className="flex between centerV"
          sx={{
            height: "32px",
            minHeight: "32px",
            maxHeight: "32px",
            alignItems: "center",
            overflow: "hidden",
          }}>
          <div
            className="authPage newLogo cursor-pointer"
            onClick={() => (window.location.href = "/")}></div>
          <Box sx={{ flexShrink: 0 }}>
            <ThemeSwitcher />
          </Box>
        </Box>

        {this.renderToggle()}

        <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <Typography className="mainTitle">{this.tr(mainTitle)}</Typography>
          <Typography className="smallTitle">{this.tr(smallTitle)}</Typography>
        </Box>

        {this.renderForm()}
      </Box>
    );
  }
}

export default function AuthPage() {
  const navigate = useNavigate();
  const location = useLocation();

  return <AuthPageBase navigate={navigate} location={location} />;
}
